module.exports = __webpack_public_path__ + "img/vilo.9979562a.jpeg";